/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum BrandTypeEnum {
    LABO = 'LABO',
    TRADEMARK = 'TRADEMARK',
}